export default function setSearchDateFromAction(searchDateFrom) {
    return {
        type: 'SET_SEARCH_DATE_FROM',
        payload: searchDateFrom
    }
}